export default [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1569,
  1520,
  1471,
  1447,
  1422,
  1390,
  1363,
  1314,
  1265,
  1236,
  1187,
  1157,
  1118,
  1089,
  1049,
  1035,
  1020,
  990,
  971,
  941,
  892,
  880,
  870,
  853,
  838,
  824,
  794,
  775,
  755,
  716,
  706,
  696,
  680,
  667,
  657,
  648,
  637,
  617,
  608,
  685,
  559,
  555,
  549,
  539,
  535,
  530,
  515,
  500,
  490,
  482,
  481,
  480,
  475,
  467,
  461,
  451,
  431,
  422,
  412,
  402,
  382,
  378,
  373,
  0,
  0,
  0,
  0,
];
